import React from "react";
import { Formik, Field, Form } from "formik";
import {
  TextField,
  Loading,
  MultiSelect,
  Select,
  PersianDataPicker,
} from "components/form";
import { required, validationWrapper, isUserName } from "lib/formValidations";
import { transformTranslateFromValues, dateTimeToserver } from "lib/helpers";
import Modal from "components/Modal";
import { TextArea } from "components/form";
import { GalleryField } from "components/form";
import MultySearchSelect from "utils/MultySearchSelect";
import extractValues from "utils/extractValues";
import AchievementComponent from "utils/AchievementComponent";
import SocialComponent from "utils/SocialComponent";
import MetaDataComponent from "utils/MetaDataComponent";
import TextFieldSlug from "components/form/TextFieldSlug";
// components

const ROLES = [
  { label: "مدیر", value: "admin" },
  { label: "نویسنده", value: "author" },
  { label: "کاربر", value: "user" },
];

export default function Add(props) {
  return (
    <>
      <Modal show={props.show} handleClose={props.close} title={props.title}>
        <Formik
          initialValues={{}}
          onSubmit={async (values, { setSubmitting, resetForm }) => {
            if (values.birthday)
              values.birthday = dateTimeToserver(values.birthday, "YYYY-MM-DD");

            const result = extractValues(values, ["matches", "leagues"]);

            await props.submit(result);
            resetForm();
            props.close();
            setSubmitting(false);
          }}
          enableReinitialize
        >
          {({ isSubmitting, dirty, values, setFieldValue }) => (
            <Form>
              <div className="modal-body gap-y-3">
                <div className="intro-x grid md:grid-cols-2 md:gap-3">
                  <Field
                    placeholder="نام"
                    label="نام :"
                    name="translations.fa.name"
                    slugFieldName="translations.fa.slug"
                    component={TextFieldSlug}
                  />
                  <Field
                    placeholder="نام(en)"
                    label="نام (en):"
                    name="translations.en.name"
                    slugFieldName="translations.en.slug"
                    component={TextFieldSlug}
                  />
                  <Field
                    placeholder="نام خانوادگی"
                    label="نام خانوادگی :"
                    name="translations.fa.lastName"
                    component={TextField}
                  />
                  <Field
                    placeholder="نام خانوادگی(en)"
                    label="نام خانوادگی(en) :"
                    name="translations.en.lastName"
                    component={TextField}
                  />

                  <Field
                    placeholder="ملیت"
                    label="ملیت :"
                    name="translations.fa.nationality"
                    component={TextField}
                  />
                  <Field
                    placeholder="ملیت(en)"
                    label="ملیت(en) :"
                    name="translations.en.nationality"
                    component={TextField}
                  />

                  <Field
                    placeholder="مدرک"
                    label="مدرک :"
                    name="translations.fa.certification"
                    component={TextField}
                  />
                  <Field
                    placeholder="مدرک(en)"
                    label="مدرک(en) :"
                    name="translations.en.certification"
                    component={TextField}
                  />

                  <Field
                    placeholder="نقش "
                    label="نقش   :"
                    name="translations.fa.role"
                    component={TextField}
                    // validate={isUserName}
                  />
                  <Field
                    placeholder="نقش  (en)"
                    label="نقش  (en) :"
                    name="translations.en.role"
                    component={TextField}
                    // validate={isUserName}
                  />

                  <Field
                    placeholder="نامک"
                    label="نامک:"
                    name="translations.fa.slug"
                    component={TextField}
                  />
                  <Field
                    placeholder="نامک(en)"
                    label="نامک(en) :"
                    name="translations.en.slug"
                    component={TextField}
                  />

                  <div className="user-datepicker">
                    <Field
                      label="تاریخ تولد :"
                      name="birthDate"
                      component={PersianDataPicker}
                    />
                  </div>

                  <Field
                    label=" مسابقات:"
                    name="matches"
                    component={MultySearchSelect}
                    searchFields="homeTeam.translations.name,awayTeam.translations.name"
                    collectionName="match"
                    showFields="homeTeam.translations.name,awayTeam.translations.name,matchDate"
                    className="w-full px-3 py-2 border rounded"
                  />

                  <Field
                    label="لیگ ها:"
                    name="leagues"
                    component={MultySearchSelect}
                    searchFields="translations.name"
                    collectionName="league"
                    showFields="translations.name"
                    className="w-full px-3 py-2 border rounded"
                  />
                </div>

                <div className="intro-y">
                  <span>تعداد بازی های قضاوت شده:</span>
                  <Field
                    label="تعداد بازی های قضاوت شده: "
                    name="matchesOfficiated"
                    component="input"
                    type="number"
                    className="w-full px-3 py-2 border rounded"
                  />
                </div>
                <div className="intro-y">
                  <span>تعداد کارت‌های زرد داده‌شده: </span>
                  <Field
                    label="تعداد کارت‌های زرد داده‌شده:"
                    name="yellowCardsIssued"
                    component="input"
                    type="number"
                    className="w-full px-3 py-2 border rounded"
                  />
                </div>

                <div className="intro-y">
                  <span>تعداد کارت‌های قرمز داده‌شده:</span>
                  <Field
                    label="تعداد کارت‌های قرمز داده‌شده:"
                    name="redCardsIssued"
                    component="input"
                    type="number"
                    className="w-full px-3 py-2 border rounded"
                  />
                  values
                </div>

                <div className="intro-y">
                  <span>تعداد پنالتی‌های اعلام‌شده:</span>
                  <Field
                    label="تعداد پنالتی‌های اعلام‌شده:"
                    name="penaltiesAwarded"
                    component="input"
                    type="number"
                    className="w-full px-3 py-2 border rounded"
                  />
                </div>

                <div className="w-full flex justify-between">
                  <div className="w-full">
                    <Field
                      label="تصویر"
                      name="profileImage"
                      dataType="id"
                      component={GalleryField}
                    />
                  </div>
                </div>

                <AchievementComponent
                  values={values}
                  setFieldValue={setFieldValue}
                  type="Referee"
                />
                <SocialComponent
                  values={values}
                  setFieldValue={setFieldValue}
                  type="Referee"
                />
                <MetaDataComponent
                  values={values}
                  setFieldValue={setFieldValue}
                  type="Referee"
                />
              </div>

              <div className="modal-footer text-right">
                <button
                  className="btn btn-primary w-20"
                  type="submit"
                  disabled={!!(isSubmitting || !dirty)}
                >
                  {" "}
                  {isSubmitting ? <Loading /> : "ذخیره"}
                </button>
                <button
                  type="button"
                  disabled={isSubmitting}
                  onClick={props.close}
                  className="btn btn-outline-secondary w-20 mr-1"
                >
                  انصراف
                </button>
              </div>
            </Form>
          )}
        </Formik>
      </Modal>
    </>
  );
}
